import React, {FC} from "react";
import {Card, CardContent, CardProps, makeStyles} from "@material-ui/core";
import {FeAdmin} from "../redux/types";
import {EditableName} from "../../../sharedComponents/EditableName";
import {LabeledTextDisplay} from "../../../sharedComponents/LabeledTextDisplay";
import {useUpdateAdmin} from "../redux/admins.hook";

const useStyles = makeStyles((theme) => ({
    spacing: {
        marginBottom: theme.spacing(2)
    }
}));

interface AdminProfileCardProps {
    admin?: FeAdmin;
    cardProps?: CardProps;
}

export const AdminProfileCard: FC<AdminProfileCardProps> = ({admin, cardProps}) => {
    const classes = useStyles();
    const {updateAdmin} = useUpdateAdmin()

    return (
        <Card {...cardProps}>
            <CardContent>
                <EditableName
                    value={admin}
                    onSubmit={updateAdmin}
                    className={classes.spacing}
                />
                <LabeledTextDisplay
                    label="Email"
                    type="email"
                    required
                    value={admin?.email}
                />
            </CardContent>
        </Card>
    )
}